import { forwardRef } from "react";
function SvgRawTrashIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="#545454"
        strokeWidth={2}
        d="M6 9h12v10c0 1-1 2-2 2H8c-1 0-2-.895-2-2V9Z"
        clipRule="evenodd"
      />
      <path
        fill="#545454"
        fillRule="evenodd"
        stroke="#545454"
        strokeWidth={2}
        d="M8 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1H8V4Z"
        clipRule="evenodd"
      />
      <path stroke="#545454" strokeWidth={2} d="M3 5h18" />
      <path
        stroke="#545454"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 12v6M14 12v6"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawTrashIcon);
export default ForwardRef;
